/**
 * Vertices on each floor level
 */

import mapF1StaticData from 'config/f1Info';
import mapF2StaticData from 'config/f2Info';
import mapF3StaticData from 'config/f3Info';

const verticesOnFloor = {
  1: mapF1StaticData.vertices,
  2: mapF2StaticData.vertices,
  3: mapF3StaticData.vertices,
};

const titleRotatesOnFloor = {
  1: mapF1StaticData.titleRotates,
  2: mapF2StaticData.titleRotates || [],
  3: mapF3StaticData.titleRotates || [],
};

export { verticesOnFloor as default, titleRotatesOnFloor };